/* ==========================================================================
   HPHS — MOCK DATA

   SERVICES, BARBERS, PHONE, BOOKSY LINKS and IMAGES below are REAL, taken from
   the client's live site (hydeparkhairsalon.biz). Biographies are the shop's
   own published words, condensed. Where the live site publishes no biography,
   the field stays a marked placeholder rather than being invented.

   PRODUCTS remain concept work — HPHS has no merchandise line yet, so every
   item is labelled Concept in the interface.

   STORIES are commissioning briefs, not written articles.

   Shopify note: SERVICES/BARBERS/STORIES become metaobjects; PRODUCTS becomes
   a real collection. Field names mirror Shopify's (handle, title, price).
   ========================================================================== */

window.HPHS = (function () {
  'use strict';

  const SHOP_PHONE = '(773) 493-6028';
  const SHOP_PHONE_HREF = 'tel:+17734936028';
  const BOOKSY = 'https://booksy.com/en-us/44985_hyde-park-hair-salon-barber_barber-shop_18229_chicago';

  const SERVICES = [
  {
    "handle": "adult-haircut",
    "title": "Adult Haircut",
    "category": "Haircuts",
    "duration": "40 min",
    "price": "$50",
    "description": "A full cut, finished properly. Clippers, shears or both &mdash; cut to how you actually wear your hair.",
    "popular": true
  },
  {
    "handle": "obama-cut",
    "title": "The Obama Cut",
    "category": "Haircuts",
    "duration": "40 min",
    "price": "$55",
    "description": "The cut the shop is known for, and has been for a long time. Ask for it by name.",
    "popular": true
  },
  {
    "handle": "hairlining-taper",
    "title": "Hairlining and Taper",
    "category": "Lineups &amp; Tapers",
    "duration": "30 min",
    "price": "$40",
    "description": "Edge-up and taper between full cuts. The visit that keeps a cut looking like the day you left the chair.",
    "popular": false
  },
  {
    "handle": "shape-ups",
    "title": "Shape Ups",
    "category": "Lineups &amp; Tapers",
    "duration": "45 min",
    "price": "Price varies",
    "description": "Shaping worked to the head and the hairline. Priced on what the cut needs.",
    "popular": false
  },
  {
    "handle": "beard-trim",
    "title": "Beard Trim",
    "category": "Beard Services",
    "duration": "20 min",
    "price": "$30",
    "description": "Shaped, edged and conditioned. Length kept where you want it.",
    "popular": false
  },
  {
    "handle": "haircut-beard",
    "title": "Haircut &amp; Beard Trim Combo",
    "category": "Hair + Beard",
    "duration": "1 hour",
    "price": "$65",
    "description": "Cut first, then the beard shaped and edged so the two read as one line.",
    "popular": true
  },
  {
    "handle": "kids-cut",
    "title": "Kids Cuts",
    "category": "Youth",
    "duration": "30 min",
    "price": "$30",
    "description": "Twelve and under. Plenty of first haircuts have happened in these chairs &mdash; we take our time.",
    "popular": false
  },
  {
    "handle": "teen-cut",
    "title": "Teen Cuts",
    "category": "Youth",
    "duration": "30 min",
    "price": "$40",
    "description": "Thirteen to seventeen. Bring a photo if you have one and we will tell you honestly how it grows out.",
    "popular": false
  },
  {
    "handle": "house-calls",
    "title": "Off-Site Services",
    "category": "Special Services",
    "duration": "45 min",
    "price": "From $130",
    "description": "House calls. For weddings, events, and customers who cannot get to Blackstone Avenue.",
    "popular": false
  }
];

  const SERVICE_CATEGORIES = ["Haircuts", "Hair + Beard", "Lineups &amp; Tapers", "Beard Services", "Youth", "Special Services"];

  const BARBERS = [
  {
    "handle": "ishmael",
    "name": "Ishmael Coye",
    "short": "Ishmael",
    "role": "Owner &amp; Master Barber",
    "img": "https://hydeparkhairsalon.biz/wp-content/uploads/2026/04/1.webp",
    "alt": "Master barber Ishmael Coye",
    "book": "https://link.booksy.com/HydeParkHairSalon",
    "booktype": "booksy",
    "specialties": [
      "Precision cuts",
      "Tapers",
      "Beard shaping"
    ],
    "bio": "Ishmael&rsquo;s passion for barbering began at age twelve, blending his love for art and precision into expressive haircuts. By high school he was booking weekly appointments from a makeshift barbershop in his mother&rsquo;s bathroom. He earned his cosmetology license in 1992 and joined Hyde Park Hair Salon at twenty &mdash; its youngest barber. Over time he mastered his craft, became the shop&rsquo;s lead barber, and eventually its owner. Under his leadership the shop relocated, expanded its services, and brought together the team working here today. He later earned his barber license as well.",
    "philosophy": "Barbering as art and precision &mdash; two things he has never treated as separate.",
    "meta": [
      [
        "Licensed",
        "Cosmetology 1992, barber licence since"
      ],
      [
        "At HPHS",
        "Since age 20"
      ],
      [
        "Books through",
        "Booksy"
      ]
    ]
  },
  {
    "handle": "tony",
    "name": "Tony",
    "short": "Tony",
    "role": "Master Barber",
    "img": "https://hydeparkhairsalon.biz/wp-content/uploads/2026/04/2.webp",
    "alt": "Master barber Tony",
    "book": "tel:+17734936028",
    "booktype": "call",
    "specialties": [
      "Classic cuts",
      "Beard work"
    ],
    "bio": "[Biography to be supplied. The live site lists Tony as a master barber taking appointments by phone; nothing further has been published, so nothing further is written here.]",
    "philosophy": "[Philosophy quote to be captured during the photography session.]",
    "meta": [
      [
        "Booking",
        "By phone"
      ],
      [
        "Experience",
        "[To be confirmed]"
      ]
    ]
  },
  {
    "handle": "maurice",
    "name": "Maurice L. McClain",
    "short": "Maurice",
    "role": "Master Barber, Trichologist &amp; Esthetician",
    "img": "https://hydeparkhairsalon.biz/wp-content/uploads/2026/04/3.webp",
    "alt": "Master barber and trichologist Maurice L. McClain",
    "book": "tel:+17734936028",
    "booktype": "call",
    "specialties": [
      "Trichology",
      "Scalp &amp; skin care",
      "Esthetics"
    ],
    "bio": "USTI/AMCA certified trichologist, educator and master barber with over thirty years of experience. A graduate and former class president of Chicago&rsquo;s Cain&rsquo;s Barber College, Maurice has dedicated his career to serving the Hyde Park community. His interest in skin and scalp care led him to become a licensed esthetician through the Douglas J. Aveda Institute and a certified trichologist. He combines holistic care with advanced technique, and his aim is to send clients out with solutions rather than products.",
    "philosophy": "Healthy hair starts with a healthy scalp, and a healthy scalp starts with how you live.",
    "meta": [
      [
        "Certified",
        "USTI/AMCA trichologist"
      ],
      [
        "Trained",
        "Cain&rsquo;s Barber College"
      ],
      [
        "Experience",
        "30+ years"
      ]
    ]
  },
  {
    "handle": "zariff",
    "name": "Zariff",
    "short": "Zariff",
    "role": "Master Barber",
    "img": "https://hydeparkhairsalon.biz/wp-content/uploads/2026/04/5.webp",
    "alt": "Master barber Zariff",
    "book": "tel:+17734936028",
    "booktype": "call",
    "specialties": [
      "Precision cuts",
      "Line-ups"
    ],
    "bio": "[Biography to be supplied. Zariff appears in the shop&rsquo;s archive photography, including images of him cutting former President Obama&rsquo;s hair, but no written profile has been published, so none is invented here.]",
    "philosophy": "[Philosophy quote to be captured during the photography session.]",
    "meta": [
      [
        "Booking",
        "By phone"
      ],
      [
        "Experience",
        "[To be confirmed]"
      ]
    ]
  },
  {
    "handle": "don-solo",
    "name": "Don Solo",
    "short": "Don Solo",
    "role": "Barber",
    "img": "https://hydeparkhairsalon.biz/wp-content/uploads/2026/04/4.webp",
    "alt": "Barber Don Solo",
    "book": "https://link.booksy.com/DonSoloDaBarber",
    "booktype": "booksy",
    "specialties": [
      "Fades",
      "Line-ups"
    ],
    "bio": "[Biography to be supplied. Don Solo takes his own bookings through Booksy.]",
    "philosophy": "[Philosophy quote to be captured during the photography session.]",
    "meta": [
      [
        "Books through",
        "Booksy"
      ],
      [
        "Experience",
        "[To be confirmed]"
      ]
    ]
  },
  {
    "handle": "diann",
    "name": "Diann E. Bishop",
    "short": "Diann",
    "role": "Master Barber &amp; Instructor",
    "img": "https://hydeparkhairsalon.biz/wp-content/uploads/2026/04/7.webp",
    "alt": "Master barber and instructor Diann E. Bishop",
    "book": "https://link.booksy.com/ClassInSession",
    "booktype": "booksy",
    "specialties": [
      "Classic barbering",
      "Hair loss practitioner",
      "Instruction"
    ],
    "bio": "Over forty years behind the chair. Diann holds a barber licence, a barber instructor licence and a hair loss practitioner certificate, and is state-approved to provide continuing education classes and domestic violence and sexual assault awareness training for the cosmetology industry. She has owned and operated successful barbershops and works in both classic and modern technique. Outside the shop she is a yoga, strength training and cycling person, and brings the same energy to her own health as to her clients&rsquo; style.",
    "philosophy": "Deliver quality service that keeps clients looking and feeling their best. That is the whole of it.",
    "meta": [
      [
        "Experience",
        "40+ years"
      ],
      [
        "Also",
        "Barber instructor"
      ],
      [
        "Books through",
        "Booksy"
      ]
    ]
  }
];

  /* Concept merchandise. No HPHS product line exists yet — every item is
     labelled CONCEPT in the interface. */
  const PRODUCTS = [
    {
      handle: 'heritage-cap',
      title: 'HPHS Heritage Cap',
      category: 'Headwear',
      price: 34,
      concept: true,
      excerpt: 'Six-panel cotton twill, low profile, brass eyelets.',
      variants: { label: 'Colour', options: ['Charcoal', 'Cream', 'Olive'] },
      story: 'The cap carries the wordmark and the founding year, nothing else. It is the thing a customer buys on the way out, and the thing a visitor takes back to another city.',
      photo: 'Cap on a folded towel, shop counter, side light'
    },
    {
      handle: 'est-1927-tee',
      title: 'Est. 1927 T-Shirt',
      category: 'Apparel',
      price: 32,
      concept: true,
      excerpt: 'Heavyweight cotton, boxy fit, printed front and back.',
      variants: { label: 'Size', options: ['S', 'M', 'L', 'XL', '2XL'] },
      story: 'Front carries the year. Back carries the address. Nothing about it needs explaining to somebody from Hyde Park.',
      photo: 'Folded tee, flat lay on cream paper'
    },
    {
      handle: 'blackstone-sweatshirt',
      title: 'Blackstone Avenue Sweatshirt',
      category: 'Apparel',
      price: 68,
      concept: true,
      excerpt: 'Heavyweight fleece, ribbed cuffs, embroidered chest mark.',
      variants: { label: 'Size', options: ['S', 'M', 'L', 'XL', '2XL'] },
      story: 'Named for the street the shop sits on. Embroidered rather than printed, so it survives being worn every winter.',
      photo: 'Sweatshirt on a wooden hanger against brick'
    },
    {
      handle: 'beard-oil',
      title: 'Beard Oil',
      category: 'Grooming',
      price: 26,
      concept: true,
      excerpt: '30ml, amber glass, cedar and black pepper.',
      variants: { label: 'Size', options: ['30ml', '50ml'] },
      story: 'The bottle the barbers already reach for at the end of a beard trim, made available to take home.',
      photo: 'Amber bottle on marble, hard side light'
    },
    {
      handle: 'comb-set',
      title: 'Carbon Comb Set',
      category: 'Grooming',
      price: 22,
      concept: true,
      excerpt: 'Two combs, cutting and dressing, saw-cut carbon.',
      variants: { label: 'Set', options: ['Two-piece', 'Four-piece'] },
      story: 'The same combs used in the shop. Heat resistant, static free, and they last decades.',
      photo: 'Combs laid on a barber towel, overhead'
    },
    {
      handle: 'gift-card',
      title: 'Gift Card',
      category: 'Gifts',
      price: 50,
      concept: true,
      excerpt: 'Redeemable against any service in the shop.',
      variants: { label: 'Value', options: ['$50', '$75', '$100'] },
      story: 'Delivered by email or printed on card stock at the counter. The most common request the shop receives in December.',
      photo: 'Gift card on cream envelope, brass foil detail'
    },
    {
      handle: 'centennial-print',
      title: 'Centennial Archive Print',
      category: 'Heritage Collection',
      price: 90,
      concept: true,
      excerpt: 'Giclée print, 16 × 20 in, unframed, numbered edition.',
      variants: { label: 'Size', options: ['16 × 20 in', '24 × 30 in'] },
      story: '[Archival image to be selected from the HPHS collection, subject to rights clearance.] Printed in a numbered edition for the shop\u2019s hundredth year.',
      photo: 'Framed archival print on a cream wall'
    },
    {
      handle: 'hyde-park-tote',
      title: 'Hyde Park Tote',
      category: 'Gifts',
      price: 24,
      concept: true,
      excerpt: '16oz canvas, long handles, screen-printed mark.',
      variants: { label: 'Colour', options: ['Natural', 'Charcoal'] },
      story: 'Sized for a farmers market run or a stack of books from 57th Street.',
      photo: 'Tote hanging on a hook by the shop door'
    }
  ];

  const PRODUCT_CATEGORIES = ['Apparel', 'Headwear', 'Grooming', 'Gifts', 'Heritage Collection'];

  /* Article directions, not written articles. Each is a commission brief. */
  const STORIES = [
    {
      handle: 'joes-barbershop-to-hphs',
      title: 'From Joe\u2019s Barbershop to HPHS',
      category: 'Legacy',
      date: 'Publication date TBC',
      read: '8 min',
      excerpt: 'The 1927 origin, the Hyde Park Theatre building, and how a shop changes its name without changing its work.',
      featured: true,
      photo: 'Archival exterior, Hyde Park Theatre building'
    },
    {
      handle: 'the-hyde-park-chair',
      title: 'The Hyde Park Chair',
      category: 'Behind the Chair',
      date: 'Publication date TBC',
      read: '6 min',
      excerpt: 'What forty-five minutes in a barber\u2019s chair is actually for, and why people keep coming back to the same one.',
      photo: 'Empty chair, morning light, shop before opening'
    },
    {
      handle: 'generations-of-craft',
      title: 'Generations of Craft',
      category: 'Barbers',
      date: 'Publication date TBC',
      read: '7 min',
      excerpt: 'How the trade passes from one barber to the next, and what gets taught that no school teaches.',
      photo: 'Two barbers, one watching the other work'
    },
    {
      handle: 'barbershop-conversations',
      title: 'Barbershop Conversations',
      category: 'Community',
      date: 'Publication date TBC',
      read: '5 min',
      excerpt: 'On politics, sport, family and everything else that gets settled between the cape and the mirror.',
      photo: 'Waiting area, three customers mid-conversation'
    },
    {
      handle: 'hyde-park-through-the-years',
      title: 'Hyde Park Through the Years',
      category: 'Chicago',
      date: 'Publication date TBC',
      read: '9 min',
      excerpt: 'The neighbourhood around the shop — the university, the lakefront, and the blocks in between.',
      photo: 'Archival Hyde Park streetscape, rights to be cleared'
    },
    {
      handle: 'a-visitors-guide',
      title: 'A Visitor\u2019s Guide to Hyde Park',
      category: 'Culture',
      date: 'Publication date TBC',
      read: '6 min',
      excerpt: 'What to do with the hours either side of your appointment, from people who work on the block.',
      photo: 'Blackstone Avenue looking north, late afternoon'
    }
  ];

  const STORY_CATEGORIES = ['Legacy', 'Chicago', 'Barbers', 'Community', 'Culture', 'Behind the Chair'];

  const SHOP = {
    name: 'Hyde Park Hair Salon & Barber',
    street: '5234 S Blackstone Ave',
    city: 'Chicago, IL 60615',
    phone: SHOP_PHONE,
    phoneHref: SHOP_PHONE_HREF,
    email: '[hello@ — address to be created on Google Workspace]',
    booksy: BOOKSY,
    instagram: 'https://instagram.com/hydepark.hairsalon',
    facebook: 'https://www.facebook.com/HydeParkHairSalonHPHS/',
    rating: '5.0',
    reviewCount: 27,
    hours: [
      { day: 'Monday', time: 'Hours to be confirmed' },
      { day: 'Tuesday', time: 'Hours to be confirmed' },
      { day: 'Wednesday', time: 'Hours to be confirmed' },
      { day: 'Thursday', time: 'Hours to be confirmed' },
      { day: 'Friday', time: 'Hours to be confirmed' },
      { day: 'Saturday', time: 'Hours to be confirmed' },
      { day: 'Sunday', time: 'Hours to be confirmed' }
    ]
  };

  /* Sample availability for the Booksy handoff mock only. */
  const SLOTS = ['9:00', '9:45', '10:30', '11:15', '12:00', '1:30', '2:15', '3:00', '3:45', '4:30', '5:15'];
  const SLOTS_TAKEN = ['10:30', '1:30', '3:45'];

  return {
    SERVICES, SERVICE_CATEGORIES,
    BARBERS, SHOP_PHONE, SHOP_PHONE_HREF, BOOKSY,
    PRODUCTS, PRODUCT_CATEGORIES,
    STORIES, STORY_CATEGORIES,
    SHOP, SLOTS, SLOTS_TAKEN
  };
})();
